import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { CommonHttpModule } from "../../providers/commonHttpModule";
import { MaCountry } from "src/app/modules/Disbursment_modules/dis-repository/pages/create-port-tariff/country.model";

@Injectable({
  providedIn: "root"
})
export class CountryService {
  constructor(private http: CommonHttpModule) {

  }

  // method to send the data to db
  CountryDataToDB(data: MaCountry): Observable<any> {
    const transformedData: MaCountry = {
      ...data,
      status: data.status === true ? "Y" : "N"
    };
    return this.http.post("create-updateCountry", transformedData).pipe(
      map((response) => {
        return response;
      })
    )
  }

  // method to get the data from db
  CountryDataFromDb(params: any): Observable<MaCountry[]> {
    return this.http.post<{ total_count: number, data: MaCountry[] }>("countrylist ", params)
      .pipe(
        map(response => {
          return response.data.map(country => ({
            ...country,
            status: country.status === 'Y' ? 'Active' : 'Inactive'
          }));
        })
      );
  }

  //method to get the country list from the db by lakshmi
  MaCountryDataFromDb(params: {}): Observable<MaCountry[]> {
    return this.http.post<{ active_vessels: any, inactive_vessels: any, country: MaCountry[] }>(
      'getmaster-data',
      params
    ).pipe(
      map(response => response.country ?? [])
    );
  }




}